import { type FC } from 'react';
import { useTranslation } from 'next-i18next';
import { extendAnalyticsData, useMediaQuery, useSportUrlParams } from '@mwl/core-lib';
import { Button } from '@/components/Button/Button';
import { lineRowLinkDataAttributes } from '@/constants';
import { useAliasedOutcomes, useMediaWidthDown } from '@/hooks';
import { checkOutcomesGroups } from '@/utils';
import type { LineRowOddsProps } from '@/types';
import { LineRowOutcomeButton } from '../LineRowOutcomeButton/LineRowOutcomeButton';
import styles from './LineRowOdds.module.scss';
import variables from '@/styles/helpers/export.module.scss';
const LineRowOdds: FC<LineRowOddsProps> = ({
  markets,
  lineId,
  linePaused,
  lineHref,
  lineStage,
  analytics
}) => {
  const {
    t
  } = useTranslation('sport');
  const isSmallDesktopScreen = useMediaQuery(`(max-width: calc(${variables.screen1100} - 1px)) and (min-width: ${variables.screen850})`);
  const isMobileScreen = useMediaWidthDown('screen850');
  const aliasedOutcomesGroups = useAliasedOutcomes(markets);
  const {
    sportId
  } = useSportUrlParams();
  const showMoreBetsButton = isSmallDesktopScreen ? checkOutcomesGroups(aliasedOutcomesGroups.slice(0, -1)) : checkOutcomesGroups(aliasedOutcomesGroups);
  return <div className={cn(styles.root, {
    [styles.showMoreBets]: showMoreBetsButton,
    [styles.sidebarOpened]: !!sportId && !isMobileScreen
  })} {...lineRowLinkDataAttributes} data-sentry-component="LineRowOdds" data-sentry-source-file="LineRowOdds.tsx">
      {aliasedOutcomesGroups?.map(outcomesGroup => <div className={styles.outcomesGroup} key={outcomesGroup.map(({
      id
    }) => id).join('_')}>
          {outcomesGroup?.map((outcome, idx) => {
        const odds = 'odds' in outcome ? outcome?.odds : '';
        return <LineRowOutcomeButton className={styles.outcomeButton} outcome={outcome} lineId={lineId} lineStage={lineStage} linePaused={linePaused} key={outcome?.id ?? idx} analytics={extendAnalyticsData(analytics, {
          text: odds,
          line_id: lineId
        })} />;
      })}
        </div>)}
      {showMoreBetsButton && <Button as="link" href={lineHref} variant="filled" fullWidth fontWeight="bold" rounded cut={false} color="grey" className={styles.oddsEmpty}>
          {t('more_bets', 'More Bets')}
        </Button>}
    </div>;
};
export { LineRowOdds };